module.exports = __webpack_public_path__ + "static/media/droplet.bc042214.mp3";